const tooltipStyle = {
	duration: 200,
	animation: 'fade',
	theme: 'light',
	arrow: true,
};

export default tooltipStyle;
